<template>
  <div>
      <div class="md-card" v-if="modalShow">
          <h6 class="md-card-header" style="text-align: left">
              {{ $t('shift.template.shiftWithTemplate') }}
              <i class="fas fa-times" style="float: right"
                 @click="modalShow = false"></i>
          </h6>
          <div class="md-card-body">
              <div class="md-card-select pad100">
                  <div>
                      <table>
                          <thead>
                          <tr>
                              <th class="pad010" v-for="label in state.weekTableLabels" :key="label.key">{{ label.label }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="row in state.weekTableRows" :key="row.id">
                              <td>{{ row.name }}</td>
                              <td v-for="label in state.weekTableLabels.filter(l => l.key !== 'name')" :key="row.id + '-' + label.key + '-td'">
                                  <checkbox :id="row.id+'-'+label.key"  :key="row.id+'-'+label.key" v-model="row[label.key]" @Update="row[label.key] = !row[label.key]" />
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <div class="right mright35">
              <buttonc type="no-border green" :label="'OK'"
                       @click="createShiftsWithTemplate(state)" />
          </div>
          <div class="right mright35">
              <buttonc type="no-border red" :label="$t('global.ui.cancel')"
                       @click="modalShow = false" />
          </div>
      </div>
    

    
</div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
import { mapState, mapGetters } from 'vuex';
import Papa from 'papaparse';
export default {
  name: 'shiftcreationwithtemplate',
  props:['ready'],
  data () {
    return {
      modalShow: false,
      storeEventMap: {},
      employeeMap: {},
      employeeEmployeeContractMap: {},
      employeePlanShiftMap: {},
      shiftTemplateGroupMap: {},
      shiftTemplateGroupFrameMap: {},
      shiftTemplateMap: {},
      employeePreferenceMap: {},
      planShiftMap: {},
      spotMap: {},
      skillMap: {},
      businessUnitMap: {},
      shiftTemplates: [],
      shiftTemplateSkillMap:{},
      shiftTemplateSkills: [],
      state : {
          weekTableLabels:[],
          weekTableRows: [],
      },

    }
  },
  created: function () {
        VueEventBus.$on("open-shiftcreationwithtemplate", this.toggleModal);
        VueEventBus.$on("open-shiftcreationwithcsv", this.openCSVImportPopup);
        VueEventBus.$on("delete-invalidtemplateshifts", this.deleteInvalidShiftsProcess);
  },
  beforeDestroy() {
        VueEventBus.$off("open-shiftcreationwithtemplate", this.toggleModal);
        VueEventBus.$off("open-shiftcreationwithcsv", this.openCSVImportPopup);
        VueEventBus.$off("delete-invalidtemplateshifts", this.deleteInvalidShiftsProcess); 
  },
  components: {

  },
  computed: {
    ...mapGetters([
        'rosterFromTo', 
        'activeEmployeeMap',
        'currentMonthEmployeeContractMap',
        'storeId', 
    ]),
  },
  watch: { 
    rosterFromTo(newVal, oldVal) {
        if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.ready){
            //this.refresh();
        }
        
    },
    storeId(newVal, oldVal) {
        if(this.ready){
            //this.refresh();
        }
        
        
    },
    ready(newVal, oldVal) {
        console.log('ready: '+newVal);
        if(newVal != oldVal && newVal){
            //this.refresh();
        }
        
    }
  },
  // methods that implement data logic.
  methods: {
    toggleModal(){
        this.refresh();
        this.modalShow = true;
    },
    refresh: function(){
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.$store.state.rosterFromTo != null  && this.$store.state.rosterFromTo.from != null && this.$store.state.rosterFromTo.to != null) {
            let view = this;
            
            console.log("Preparing shift creation")
            this.refreshState()
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                console.log(error)
            });
        }
    },
    refreshState(){
        let view = this;
        let storeId = this.$store.state.storeId;
        let rosterFromTo = this.rosterFromTo;
        return this.$helpers.GetPlanShiftMap().then(map=> {
                view.planShiftMap = map;
                return view.$helpers.GetEmployeePreferenceMap();
            }).then(map=> {
                view.employeePreferenceMap = map;
                return view.$helpers.GetBusinessUnitMap();
            }).then(map => {
                view.businessUnitMap = map;
                return view.$helpers.GetSpotMap();
            }).then(map => {
                view.spotMap = map;
                return view.$helpers.GetSkillMap();
            }).then(map => {
                view.skillMap = map;
                return this.loadShiftTemplateGroups(storeId);
            }).then(response => {
                view.updateShiftTemplateGroups(response.data);
                return this.loadShiftTemplateGroupFrames(storeId, rosterFromTo);
            }).then(response => {
                view.updateShiftTemplateGroupFrames(response.data);
                return this.loadStoreEvents(storeId, rosterFromTo);
            }).then(response => {
                view.updateStoreEvents(response.data);
                let eventPayload = {ids: []};
                for(let i = 0; i < response.data.length; i++){
                    eventPayload.ids.push(response.data[i].id);
                }
                return view.loadShiftTemplatesPagedCompletely(eventPayload, storeId, rosterFromTo);
            }).then(data => {
                view.updateShiftTemplates(data, view.spotMap, view.storeEventMap);
                let templatePayload = {ids: []};
                /*
                for(let i = 0; i < data.length; i++){
                    templatePayload.ids.push(data[i].id);
                } */
                return view.loadShiftTemplateSkills(templatePayload, storeId);
            }).then(response => {
                view.updateShiftTemplateSkills(response.data);
                view.state = view.setupState(storeId, rosterFromTo, view.shiftTemplateGroupMap, view.shiftTemplateGroupFrameMap, view.businessUnitMap, view.planShiftMap, view.shiftTemplateMap, view.storeEventMap, view.shiftTemplateSkillMap, view.employeePreferenceMap);
                return new Promise((resolve, reject) => {
                    resolve(true);
                })
            })
    },
    setupState(storeId, rosterFromTo, shiftTemplateGroupMap, shiftTemplateGroupFrameMap, businessUnitMap, planShiftMap, shiftTemplateMap, storeEventMap, shiftTemplateSkillMap, employeePreferenceMap){
        let isCurrentOrFutureMonth = this.GenerateIsCurrentOrFutureMonth(rosterFromTo);
        let weekTableLabels = this.GenerateWeekTableLabels(rosterFromTo);
        let weekTableRows = this.GenerateWeekTableRows(shiftTemplateGroupMap, businessUnitMap, weekTableLabels);
        let shiftMaps = this.GenerateShiftTemplateGeneratedMaps(planShiftMap);
        let shiftTemplateGeneratedMap = shiftMaps.shiftTemplateGeneratedMap;
        let employeePlanShiftMap = shiftMaps.employeePlanShiftMap;

        let shiftTemplateValidMomentMap = this.GenerateShiftTemplateValidMomentMap(shiftTemplateMap);
        let shiftTemplateGroupFrameByGroupMap = this.GenerateShiftTemplateGroupFrameByGroupMap(shiftTemplateGroupFrameMap);
        let employeeEmployeeContractMap = this.GenerateEmployeeEmployeeContractMap(this.currentMonthEmployeeContractMap);
        let employeeEmployeePreferenceMap  = this.GenerateEmployeeEmployeePreferenceMap(employeePreferenceMap);

        return {
            storeId: storeId,
            rosterFromTo: rosterFromTo,
            planShiftMap: planShiftMap,
            shiftTemplateMap: shiftTemplateMap, 
            storeEventMap: storeEventMap,
            isCurrentOrFutureMonth: isCurrentOrFutureMonth,
            weekTableLabels: weekTableLabels,
            weekTableRows: weekTableRows,
            shiftTemplateGeneratedMap: shiftTemplateGeneratedMap,
            shiftTemplateValidMomentMap: shiftTemplateValidMomentMap,
            shiftTemplateSkillmap: shiftTemplateSkillMap,
            shiftTemplateGroupFrameByGroupMap: shiftTemplateGroupFrameByGroupMap,
            employeePlanShiftMap: employeePlanShiftMap,
            employeeEmployeeContractMap: employeeEmployeeContractMap,
            employeeEmployeePreferenceMap: employeeEmployeePreferenceMap,
        }

    },
    GenerateEmployeeEmployeePreferenceMap(employeePreferenceMap){
        let map = {};
        Object.values(employeePreferenceMap).forEach(preference => {
            if(!map[preference.employeeId]){
                map[preference.employeeId] = [];
            }
            map[preference.employeeId].push({id: preference.id, state: preference.state, from: this.$helpers.getMomentFromStringTZ(preference.from), to: this.$helpers.getMomentFromStringTZ(preference.to)});
        });

        return map;
    },
    GenerateIsCurrentOrFutureMonth(rosterFromTo) {
        if(rosterFromTo){
            let currentDate = this.$helpers.getCurrentMonthMomentTZ().startOf('month');
            let selectedMonth = this.$helpers.getMomentFromValuesTZ(rosterFromTo.year, rosterFromTo.month, 1).startOf('month');
            return selectedMonth >= currentDate;
        } else {
            return false;
        }
                
    },
    GenerateWeekTableLabels(rosterFromTo){
        let labels = [];
        if(rosterFromTo){
            let frameStart = this.$helpers.getMomentFromStringTZ(rosterFromTo.from);
            let frameEnd = this.$helpers.getMomentFromStringTZ(rosterFromTo.to);
            console.log("FRAME START: "+frameStart.format());
            console.log("FRAME END: "+frameEnd.format());
            labels.push({key: 'name', label: this.$t('shift.main.group'), thClass: 'documentsTh', tdClass: 'documentsTd', isWeek: false})
            while(frameEnd.diff(frameStart) > 0){
                let key = frameStart.isoWeek()+'-'+frameStart.isoWeekYear();
                let label = this.$t('shift.main.calendarWeekShort')+frameStart.isoWeek()+' '+frameStart.isoWeekYear();
                let weekStart = frameStart.clone().startOf('isoWeek');
                let weekEnd = weekStart.clone().add(7,'days');
                labels.push({key: key, label: label, thClass: 'documentsTh', tdClass: 'documentsTd', isWeek: true, weekStart: weekStart, weekEnd: weekEnd});
                frameStart.add(7, "days");
            }
        }
        
        return labels;
    },
    GenerateWeekTableRows(shiftTemplateGroupMap, businessUnitMap, weekTableLabels){
        let rows = [];
        Object.keys(shiftTemplateGroupMap).forEach(k => {
            let shiftTemplateGroup = shiftTemplateGroupMap[k];
            let label = businessUnitMap[shiftTemplateGroup.unitId] ? (shiftTemplateGroup.name+': '+businessUnitMap[shiftTemplateGroup.unitId].name) : shiftTemplateGroup.name;
            let row = {name: label, id: shiftTemplateGroup.id};
            weekTableLabels.forEach(tableLabel => {
                if(tableLabel.isWeek){
                    row[tableLabel.key] = true;
                }
                
            });
            rows.push(row);
        })
        return rows;
    },
    GenerateShiftTemplateGroupFrameByGroupMap(shiftTemplateGroupFrameMap){
        let map = {};
        Object.values(shiftTemplateGroupFrameMap).forEach(frame => {
            if(!map[frame.groupId]){
                map[frame.groupId] = [];
            }
            map[frame.groupId].push(frame);
        })
        return map;
    },
    GenerateShiftTemplateGeneratedMaps(planShiftMap) {
        let map = {};
        let employeePlanShiftMap = {};
        Object.values(planShiftMap).forEach(planShift => {
            if(planShift.templateId != null){
                let date_key = this.$helpers.getMomentFromStringTZ(planShift.historicFrom).format('YYYY-MM-DD');
                if(!map[date_key]){
                    map[date_key] = {}
                }
                let dayMap = map[date_key];
                if(!dayMap[planShift.templateId]){
                    dayMap[planShift.templateId] = 0;
                }
                dayMap[planShift.templateId] +=1;
            }
            if(planShift.employeeId != null){
                if(!employeePlanShiftMap[planShift.employeeId]){
                    employeePlanShiftMap[planShift.employeeId] = [];
                }
                employeePlanShiftMap[planShift.employeeId].push({from: this.$helpers.getMomentFromStringTZ(planShift.from), to: this.$helpers.getMomentFromStringTZ(planShift.to)});
            }

        });
        //console.log(map)
        return {shiftTemplateGeneratedMap: map, employeePlanShiftMap: employeePlanShiftMap};
    },
    GenerateEmployeeEmployeeContractMap(employeeContractMap){
        let map = {};
        Object.values(employeeContractMap).forEach(contract => {
            if(!map[contract.employeeId]){
                map[contract.employeeId] = [];
            }
            map[contract.employeeId].push({from: this.$helpers.getMomentFromStringTZ(contract.from), to: contract.to != null ? this.$helpers.getMomentFromStringTZ(contract.to) : null});
        });
        return map;
    },
    GenerateShiftTemplateValidMomentMap(shiftTemplateMap) {
        let map = {};
        Object.values(shiftTemplateMap).forEach(template => {
            let validFromMoment = template.validFrom ? this.$helpers.getMomentFromStringTZ(template.validFrom) : null;
            let validToMoment = template.validTo ? this.$helpers.getMomentFromStringTZ(template.validTo) : null;
            map[template.id] = {from: validFromMoment, to: validToMoment};
        });
        return map;
    },
    
    doShiftLoadingAndCreationProcess(storeId, rosterFromTo, businessUnitMap, spotMap, skillMap, planShiftMap, employeePreferenceMap) {
        let view = this;
        
        let shiftTemplateGroupMap;
        let shiftTemplateGroupFrameMap;
        let shiftTemplateMap;
        let storeEventMap;
        let shiftTemplateSkillMap;
        let state;
        console.log("DOING SHIFT LOAD AND CREATE")
        return this.loadShiftTemplateGroups(storeId)
        .then(response => {
            view.updateShiftTemplateGroups(response.data);
            shiftTemplateGroupMap = view.shiftTemplateGroupMap;
            return this.loadShiftTemplateGroupFrames(storeId, rosterFromTo);
        })
        .then(response => {
            view.updateShiftTemplateGroupFrames(response.data);
            shiftTemplateGroupFrameMap = view.shiftTemplateGroupFrameMap;
            return this.loadStoreEvents(storeId, rosterFromTo);
        }).then(response => {
            view.updateStoreEvents(response.data);
            storeEventMap = view.storeEventMap;
            let eventPayload = {ids: []};
            for(let i = 0; i < response.data.length; i++){
                eventPayload.ids.push(response.data[i].id);
            }
            return view.loadShiftTemplatesPagedCompletely(eventPayload, storeId, rosterFromTo);
        }).then(data => {
            view.updateShiftTemplates(data, spotMap, storeEventMap);
            shiftTemplateMap = view.shiftTemplateMap;
            let templatePayload = {ids: []};
            /*
            for(let i = 0; i < data.length; i++){
                templatePayload.ids.push(data[i].id);
            }*/
            return view.loadShiftTemplateSkills(templatePayload, storeId);
        }).then(response => {
            view.updateShiftTemplateSkills(response.data);
            shiftTemplateSkillMap = view.shiftTemplateSkillMap;
            
            state = view.setupState(storeId, rosterFromTo, shiftTemplateGroupMap, shiftTemplateGroupFrameMap, businessUnitMap, planShiftMap, shiftTemplateMap, storeEventMap, shiftTemplateSkillMap, employeePreferenceMap);
            return view.deleteInvalidTemplateShiftsReturning(state);
        }).then(map => {
            return view.createShiftsWithTemplateReturning(state);
        })
    },

    checkIfValidGroupFrameExists(state, template, day){
        if(!state.shiftTemplateGroupFrameByGroupMap[template.groupId]){
            return false;
        } else {
            let validFrame = state.shiftTemplateGroupFrameByGroupMap[template.groupId].find(frame => (frame.fromMoment == null || frame.fromMoment <= day) && (frame.toMoment == null || frame.toMoment > day));
            return validFrame != null;
        }
    },
    generateShiftRequests(state, considerAlreadyCreated = true){
        let shiftRequests = [];
        let template;
        state.weekTableLabels.filter(weekLabel => weekLabel.isWeek).forEach(weekLabel => {
            
            let weekStart = weekLabel.weekStart.clone();
            //console.log(weekStart.format())
            let weekIterator = weekStart.clone();
            let weekEnd = weekLabel.weekEnd.clone();
            let selectedTemplateGroups = state.weekTableRows.filter(row => row[weekLabel.key] == true).map(row => row.id);
            
            let regularTemplates = Object.values(state.shiftTemplateMap).filter(t => t.eventId == null && selectedTemplateGroups.includes(t.groupId));
            
            let eventTemplates = Object.values(state.shiftTemplateMap).filter(t => t.eventId != null && selectedTemplateGroups.includes(t.groupId));

            //check if theres events overlapping the WEEK
            let eventIds = Object.values(state.storeEventMap).filter(e => e.toMoment > weekStart && e.fromMoment < weekEnd).map(e => e.id);
            let noShiftEventIds = eventIds.filter(id => state.storeEventMap[id].shiftCreationMode == 2);
            
            let replacingEventIds = eventIds.filter(id => state.storeEventMap[id].shiftCreationMode == 0);
           
            while(weekEnd.diff(weekIterator) > 0){
            
                let dayStart = weekIterator.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
                let dayEnd = dayStart.clone().add(1,'days');
                let filteredEventTemplates = eventTemplates.filter(t => eventIds.includes(t.eventId) && this.checkIfValidGroupFrameExists(state, t, dayStart));

                let alreadyCreatedMap = considerAlreadyCreated ? (state.shiftTemplateGeneratedMap[dayStart.format('YYYY-MM-DD')] ? state.shiftTemplateGeneratedMap[dayStart.format('YYYY-MM-DD')] : {}) : {};
                
                //if theres any templates for any overlapping events, only create shifts from those templates
                let eventShiftsCreated = {};
                if(filteredEventTemplates.length > 0){
                    filteredEventTemplates.filter(t => t.weekDays.includes(weekIterator.isoWeekday())).forEach(template => {
                        let day = this.$helpers.getMomentTZ().year(weekIterator.year()).month(weekIterator.month()).date(weekIterator.date()).startOf('day');
                        //DST bullshit here
                        let startOfYear = this.$helpers.getMomentTZ().startOf('year');
                        let from = this.$helpers.getMomentFromStringUTC(template.from, 'HH:mm');
                        from = startOfYear.clone().hours(from.hours()).minutes(from.minutes())
                        let to = this.$helpers.getMomentFromStringUTC(template.to, 'HH:mm');
                        to = startOfYear.clone().hours(to.hours()).minutes(to.minutes())
                        if(to.diff(from) <= 0){
                            to.add(1, 'days')
                            
                        }
                        //instead of using the hour and time value from template we calculate the diff to set the to date, because of DST
                        let diff = to.diff(from);
                        from = day.clone().hours(from.hours()).minutes(from.minutes()); 
                        to = from.clone().add(diff, 'milliseconds');
                        

                        let breakFrom = null;
                        if(template.breakFrom != null){
                            breakFrom = this.$helpers.getMomentFromStringUTC(template.breakFrom, 'HH:mm');
                            breakFrom = day.clone().hours(breakFrom.hours()).minutes(breakFrom.minutes());
                            if(breakFrom < from){
                                breakFrom.add(24, 'hours')
                            }
                        }

                        let shiftAllowed = noShiftEventIds.filter(id => state.storeEventMap[id].fromMoment < to && state.storeEventMap[id].toMoment > from && from >= state.storeEventMap[id].fromMoment).length == 0;
                        let event = state.storeEventMap[template.eventId];
                        if(shiftAllowed){
                            
                            let alreadyCreatedCount = alreadyCreatedMap[template.id] ? alreadyCreatedMap[template.id] : 0;
                            let totalCreatedCount = alreadyCreatedCount;

                            for(let j = 0; j < (template.count - alreadyCreatedCount); j++){
                                let request = {
                                    from: from.format(),
                                    to: to.format(),
                                    breakFrom: breakFrom == null ? null : breakFrom.format(),
                                    spotId: template.spotId,
                                    projectId: template.projectId,
                                    fromLocationId: template.fromLocationId ? template.fromLocationId : null,
                                    toLocationId: template.toLocationId ? template.toLocationId : null,
                                    historicFrom: from.format(), 
                                    historicTo: to.format(),
                                    historicSpotId: template.spotId,
                                    workValue: template.workValue,
                                    historicWorkValue: template.workValue,
                                    breakValue: template.breakValue,
                                    holidayWorkValue: template.holidayWorkValue,
                                    workValueMultiplier: 1.0,
                                    skillMultiplier: 1,
                                    tasks: template.tasks,
                                    templateId: template.id,
                                    costCenterId: template.costCenterId ? template.costCenterId : null,
                                    pinned: false
                                }
                                request.historicBreakFrom = request.breakFrom;
                                request.historicBreakValue = request.breakValue;

                                if(template.fakeTemplate){
                                    request.templateId= null
                                }
                                
                                totalCreatedCount += 1;

                                if(template.employeeId != null){
                                    let hasContract = false;
                                    let contracts = state.employeeEmployeeContractMap[template.employeeId];
                                    if(contracts){
                                        let contract = contracts.find(c => c.from <= from && (c.to == null || c.to > from));
                                        if(contract){
                                            hasContract = true;
                                        }
                                    }
                                    let noOverlappingShift = true;
                                    let employeeShifts = state.employeePlanShiftMap[template.employeeId];
                                    if(employeeShifts){
                                        let overlappingShift = employeeShifts.find(shift => shift.from < to && shift.to > from);
                                        if(overlappingShift){
                                            noOverlappingShift = false;
                                        }
                                    }
                                    let preferences = state.employeeEmployeePreferenceMap[template.employeeId];
                                    if(preferences){
                                        let preference = preferences.find(p => from >= p.from && from < p.to && p.state == 1);
                                        
                                        if(preference){
                                            noOverlappingShift = false;
                                        }
                                    }
                                    
                                    if(hasContract && noOverlappingShift){
                                        request.employeeId = template.employeeId;
                                        request.pinned = true;
                                    }
                                }
                                
                                shiftRequests.push(request);
                            }
                            if(event.shiftCreationMode == 0 && totalCreatedCount > 0){
                                //let replaceCondition = event.fromMoment.date() == from.date() &&  event.fromMoment.month() == from.month() && event.fromMoment.year() == from.year();
                                let replaceCondition = event.toMoment > from && event.fromMoment < to && from >= event.fromMoment;
                                //if shift is on same date as event
                                if(replaceCondition){
                                    let fromKey = from.format('YYYY-MM-DD')
                                    if(!eventShiftsCreated[template.groupId]){
                                        eventShiftsCreated[template.groupId] = {};
                                    }
                                    if(!eventShiftsCreated[template.groupId][fromKey]){
                                        eventShiftsCreated[template.groupId][fromKey] = 0;
                                    }
                                    eventShiftsCreated[template.groupId][fromKey] +=totalCreatedCount;
                                }
                                   
                            } 
                        }
                        
                    });
                } 
                
                //create shifts for any regular template whose weekDays includes the weekday of current startDate
                regularTemplates.filter(t => this.checkIfValidGroupFrameExists(state, t, dayStart) && t.weekDays.includes(weekIterator.isoWeekday()) && this.checkValidOverlap(dayStart, dayEnd, state.shiftTemplateValidMomentMap[t.id].from, state.shiftTemplateValidMomentMap[t.id].to))
                .forEach(template => {
                        let day = this.$helpers.getMomentTZ().year(weekIterator.year()).month(weekIterator.month()).date(weekIterator.date()).startOf('day');
                        
                        //DST bullshit here
                        let startOfYear = this.$helpers.getMomentTZ().startOf('year');
                        let from = this.$helpers.getMomentFromStringUTC(template.from, 'HH:mm');
                        from = startOfYear.clone().hours(from.hours()).minutes(from.minutes())
                        let to = this.$helpers.getMomentFromStringUTC(template.to, 'HH:mm');
                        to = startOfYear.clone().hours(to.hours()).minutes(to.minutes())
                        if(to.diff(from) <= 0){
                            to.add(1, 'days')
                            
                        }
                        //instead of using the hour and time value from template we calculate the diff to set the to date, because of DST
                        let diff = to.diff(from);
                        from = day.clone().hours(from.hours()).minutes(from.minutes()); 
                        to = from.clone().add(diff, 'milliseconds');
                        
                        
                        

                        let breakFrom = null;
                        if(template.breakFrom != null){
                            breakFrom = this.$helpers.getMomentFromStringUTC(template.breakFrom, 'HH:mm');
                            breakFrom = day.clone().hours(breakFrom.hours()).minutes(breakFrom.minutes());
                            if(breakFrom < from){
                                breakFrom.add(24, 'hours')
                            }
                        }


                        

                        let shiftAllowed = noShiftEventIds.filter(id => state.storeEventMap[id].fromMoment < to && state.storeEventMap[id].toMoment > from && from >= state.storeEventMap[id].fromMoment).length == 0;
                        //shiftAllowed = shiftAllowed && !eventShiftsCreated[template.groupId]; //&& (replacingEventIds.filter(id => this.storeEventMap[id].fromMoment.isBefore(to) && this.storeEventMap[id].toMoment.isAfter(from) && from.isSameOrAfter(this.storeEventMap[id].fromMoment)).length == 0)
                        let fromKey = from.format('YYYY-MM-DD')
                        shiftAllowed = shiftAllowed && (!eventShiftsCreated[template.groupId] || !eventShiftsCreated[template.groupId][fromKey] || eventShiftsCreated[template.groupId][fromKey] == 0);
                        
                        if(shiftAllowed){
                           
                            let alreadyCreatedCount = alreadyCreatedMap[template.id] ? alreadyCreatedMap[template.id] : 0;
                            for(let j = 0; j < (template.count - alreadyCreatedCount); j++){
                                let request = {
                                    from: from.format(),
                                    to: to.format(),
                                    breakFrom: breakFrom == null ? null : breakFrom.format(),
                                    spotId: template.spotId,
                                    projectId: template.projectId,
                                    fromLocationId: template.fromLocationId ? template.fromLocationId : null,
                                    toLocationId: template.toLocationId ? template.toLocationId : null,
                                    historicFrom: from.format(), 
                                    historicTo: to.format(),
                                    historicSpotId: template.spotId,
                                    workValue: template.workValue,
                                    historicWorkValue: template.workValue,
                                    breakValue: template.breakValue,
                                    holidayWorkValue: template.holidayWorkValue,
                                    workValueMultiplier: 1.0,
                                    skillMultiplier: 1,
                                    tasks: template.tasks,
                                    templateId: template.id,
                                    costCenterId: template.costCenterId ? template.costCenterId : null,
                                    pinned: false
                                }
                                request.historicBreakFrom = request.breakFrom;
                                request.historicBreakValue = request.breakValue;
                                
                                if(template.fakeTemplate){
                                    request.templateId= null
                                }
                                
                                if(template.employeeId != null){
                                    let hasContract = false;
                                    let contracts = state.employeeEmployeeContractMap[template.employeeId];
                                    if(contracts){
                                        let contract = contracts.find(c => c.from <= from && (c.to == null || c.to > from));
                                        if(contract){
                                            hasContract = true;
                                        }
                                    }
                                    let noOverlappingShift = true;
                                    let employeeShifts = state.employeePlanShiftMap[template.employeeId];
                                    if(employeeShifts){
                                        let overlappingShift = employeeShifts.find(shift => shift.from < to && shift.to > from);
                                        if(overlappingShift){
                                            noOverlappingShift = false;
                                        }
                                    }
                                    let preferences = state.employeeEmployeePreferenceMap[template.employeeId];
                                    if(preferences){
                                        let preference = preferences.find(p => from >= p.from && from < p.to && p.state == 1);
                                        
                                        if(preference){
                                            noOverlappingShift = false;
                                        }
                                    }
                                    if(hasContract && noOverlappingShift){
                                        request.employeeId = template.employeeId;
                                        request.pinned = true;
                                    }
                                }
                                //console.log(JSON.stringify(request))
                                shiftRequests.push(request);
                                
                            }
                        }
                    
                })
                
                
                weekIterator.add(1, 'days');    
            }

        });
        
        return shiftRequests;
    },
    generateShiftTemplateCheckMap(state){
        let shiftCheckMap = {};
        let template;
        state.weekTableLabels.filter(weekLabel => weekLabel.isWeek).forEach(weekLabel => {
            
            let weekStart = weekLabel.weekStart.clone();
            let weekIterator = weekStart.clone();
            let weekEnd = weekLabel.weekEnd.clone();
            let selectedTemplateGroups = state.weekTableRows.filter(row => row[weekLabel.key] == true).map(row => row.id);
            
            let regularTemplates = Object.values(state.shiftTemplateMap).filter(t => t.eventId == null && selectedTemplateGroups.includes(t.groupId));
            
            let eventTemplates = Object.values(state.shiftTemplateMap).filter(t => t.eventId != null && selectedTemplateGroups.includes(t.groupId));

            //check if theres events overlapping the WEEK
            let eventIds = Object.values(state.storeEventMap).filter(e => e.toMoment > weekStart && e.fromMoment < weekEnd).map(e => e.id);
            let noShiftEventIds = eventIds.filter(id => state.storeEventMap[id].shiftCreationMode == 2);
            
            let replacingEventIds = eventIds.filter(id => state.storeEventMap[id].shiftCreationMode == 0);
           
            while(weekEnd.diff(weekIterator) > 0){
            
                let dayStart = weekIterator.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
                let dayEnd = dayStart.clone().add(1,'days');
                let filteredEventTemplates = eventTemplates.filter(t => eventIds.includes(t.eventId) && this.checkIfValidGroupFrameExists(state, t, dayStart));

               
                //if theres any templates for any overlapping events, only create shifts from those templates
                let eventShiftsCreated = {};
                if(filteredEventTemplates.length > 0){
                    filteredEventTemplates.filter(t => t.weekDays.includes(weekIterator.isoWeekday())).forEach(template => {
                        let day = this.$helpers.getMomentTZ().year(weekIterator.year()).month(weekIterator.month()).date(weekIterator.date()).startOf('day');
                        let from = this.$helpers.getMomentFromStringTZ(template.from, 'HH:mm');
                        from = day.clone().hours(from.hours()).minutes(from.minutes());
                        let to = this.$helpers.getMomentFromStringTZ(template.to, 'HH:mm');
                        to = day.clone().hours(to.hours()).minutes(to.minutes());
                        
                        if(to.diff(from) <= 0){
                            to.add(1, 'days')
                        }
 
                        let shiftAllowed = noShiftEventIds.filter(id => state.storeEventMap[id].fromMoment < to && state.storeEventMap[id].toMoment > from && from >= state.storeEventMap[id].fromMoment).length == 0;
                        let event = state.storeEventMap[template.eventId];
                        if(shiftAllowed){
                            
                           
                            let totalCreatedCount = 0;
                            let checkMapKey = from.format('YYYY-MM-DD')+"-"+template.id;
                            for(let j = 0; j < template.count; j++){
                                if(!shiftCheckMap[checkMapKey]){
                                    shiftCheckMap[checkMapKey] = 0;
                                }
                                shiftCheckMap[checkMapKey] +=1;
                                
                                totalCreatedCount += 1;
                            }
                            if(event.shiftCreationMode == 0 && totalCreatedCount > 0){
                                //let replaceCondition = event.fromMoment.date() == from.date() &&  event.fromMoment.month() == from.month() && event.fromMoment.year() == from.year();
                                let replaceCondition = event.toMoment > from && event.fromMoment < to && from >= event.fromMoment;
                                //if shift is on same date as event
                                if(replaceCondition){
                                    let fromKey = from.format('YYYY-MM-DD')
                                    if(!eventShiftsCreated[template.groupId]){
                                        eventShiftsCreated[template.groupId] = {};
                                    }
                                    if(!eventShiftsCreated[template.groupId][fromKey]){
                                        eventShiftsCreated[template.groupId][fromKey] = 0;
                                    }
                                    eventShiftsCreated[template.groupId][fromKey] +=totalCreatedCount;
                                }
                                   
                            } 
                        }
                        
                    });
                } 
                
                //create shifts for any regular template whose weekDays includes the weekday of current startDate
                regularTemplates.filter(t => this.checkIfValidGroupFrameExists(state, t, dayStart) && t.weekDays.includes(weekIterator.isoWeekday()) && this.checkValidOverlap(dayStart, dayEnd, state.shiftTemplateValidMomentMap[t.id].from, state.shiftTemplateValidMomentMap[t.id].to))
                .forEach(template => {
                        
                        let day = this.$helpers.getMomentTZ().year(weekIterator.year()).month(weekIterator.month()).date(weekIterator.date()).startOf('day');
                        let from = this.$helpers.getMomentFromStringTZ(template.from, 'HH:mm');
                        from = day.clone().hours(from.hours()).minutes(from.minutes());
                        let to = this.$helpers.getMomentFromStringTZ(template.to, 'HH:mm');
                        to = day.clone().hours(to.hours()).minutes(to.minutes());
                        
                        if(to.diff(from) <= 0){
                                to.add(1, 'days')
                        }
                        
                        let shiftAllowed = noShiftEventIds.filter(id => state.storeEventMap[id].fromMoment < to && state.storeEventMap[id].toMoment > from && from >= state.storeEventMap[id].fromMoment).length == 0;
                        //shiftAllowed = shiftAllowed && !eventShiftsCreated[template.groupId]; //&& (replacingEventIds.filter(id => this.storeEventMap[id].fromMoment.isBefore(to) && this.storeEventMap[id].toMoment.isAfter(from) && from.isSameOrAfter(this.storeEventMap[id].fromMoment)).length == 0)
                        let fromKey = from.format('YYYY-MM-DD')
                        shiftAllowed = shiftAllowed && (!eventShiftsCreated[template.groupId] || !eventShiftsCreated[template.groupId][fromKey] || eventShiftsCreated[template.groupId][fromKey] == 0);
                        
                        if(shiftAllowed){
                           
                            let checkMapKey = from.format('YYYY-MM-DD')+"-"+template.id;
                            for(let j = 0; j < template.count; j++){
                                if(!shiftCheckMap[checkMapKey]){
                                    shiftCheckMap[checkMapKey] = 0;
                                }
                                shiftCheckMap[checkMapKey] +=1;
                            }
                        }
                    
                })
                
                
                weekIterator.add(1, 'days');    
            }

        });
        
        return shiftCheckMap;
    },
    
    createShiftsWithTemplateReturning: function(state) {
        let view = this;
        return new Promise((resolve, reject) => {
                let shiftRequests = this.generateShiftRequests(state, true);
            
                if(shiftRequests.length > 0 && state.isCurrentOrFutureMonth){
                    let url = '/api/sec/planshift/multi';
                    let params = {
                        storeId: state.storeId ? state.storeId : this.$store.state.storeId
                    }

                    let payload = {
                        requests: shiftRequests
                    }
                    view.$helpers.RecursivePOSTAny(url, payload, [], params, 1000, 'requests', 'data')
                    .then(result => {
                        for(let i = 0; i< result.length; i++){
                            
                            let shift = result[i];
                            state.planShiftMap[shift.id] = shift;
        
                        }
                        view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('shift.main.shiftsAdded'))
                        view.alreadyCreating = false;
                        resolve(state.planShiftMap);
                        

                    
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.addShiftsError'));
                        view.alreadyCreating = false;
                        resolve(state.planShiftMap);
                        console.log(error)
                    })   
                    
                } else {
                    view.alreadyCreating = false;
                    resolve(state.planShiftMap);
                    
                }
            })
    },
    createShifts(requests){
        let view = this;
  
        
        
        if(requests.length > 0){
            let url = '/api/sec/planshift/multi';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/multi');

            let payload = {
                requests: requests
            }
                
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        } else {
           return new Promise((resolve, reject) => {
               resolve([]);
           })
        }
    },
    deleteShifts(ids){
        let view = this;
        let url = '/api/sec/planshift/any/delete';
        let params = {
            storeId: view.$store.state.storeId
        }

        let payload = {
            storeId: view.$store.state.storeId,
            ids: ids,
        }
        if(ids.length > 0){
            return this.$helpers.RecursivePOSTAny(url, payload, []);
            
        } else {
           return new Promise((resolve, reject) => {
               resolve([]);
           })
        }
        
    },
    createShiftsWithTemplate: function(state) {
        let view = this;
        
        
        
        let shiftRequests = this.generateShiftRequests(state, true);
        
        if(shiftRequests.length > 0){
            let url = '/api/sec/planshift/multi';
            

            let params = {
                storeId: state.storeId ? state.storeId : this.$store.state.storeId
            }
            let payload = {
                requests: shiftRequests
            }

            view.$helpers.RecursivePOSTAny(url, payload, [], params, 1000, 'requests', 'data')
            .then(result => {
                
                view.$helpers.success(view.$t('global.ui.createSuccessful'), view.$t('shift.main.shiftsAdded'))
                view.$store.commit("invalidateState", {states: ['planShiftMapState']});
                view.$emit("refreshShifts");
                view.modalShow = false;

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.addShiftsError'));
                console.log(error)
            })   
                
        } else {
           view.modalShow = false;
        }
    },
    deleteInvalidTemplateShiftsReturning(state){
        let keepAssigned = true;
        let view = this;
        let checkMap = this.generateShiftTemplateCheckMap(state);
        let shiftsToDelete = [];
        let countMap = {};
        let shifts = [];
        if(keepAssigned){
            shifts = Object.values(state.planShiftMap).filter(s => !s.published && s.templateId != null && s.employeeId == null);
        } else {
            shifts = Object.values(state.planShiftMap).filter(s => !s.published && s.templateId != null);
        }
        let rosterFrom = this.$helpers.getMomentFromStringTZ(state.rosterFromTo.from);
        let rosterTo = this.$helpers.getMomentFromStringTZ(state.rosterFromTo.to);
        
        shifts.forEach(s => {
            if(s.historicFrom){
                let d = this.$helpers.getMomentFromStringTZ(s.historicFrom);
                if(d >= rosterFrom && d < rosterTo){
                    //only delete within roster from to
                    let checkKey = this.$helpers.getMomentFromStringTZ(s.historicFrom).format('YYYY-MM-DD')+"-"+s.templateId;
                    if(!countMap[checkKey]){
                        countMap[checkKey] = 0;
                    }
                    countMap[checkKey] += 1;
                    let currentCount = countMap[checkKey];
                    let supposedToCount = checkMap[checkKey];
                    if(supposedToCount == null || currentCount > supposedToCount){
                        shiftsToDelete.push(s.id);
                    }
                }
                
            }
            
        })
        return new Promise((resolve, reject) => {
            if(shiftsToDelete.length > 0){
                let url = '/api/sec/planshift/any/delete';

                        
                let payload = {
                    ids: shiftsToDelete,
                }
                view.$helpers.RecursivePOSTAny(url, payload, [])
                .then(result => {
                    let deletedIds = result;
                    let payload = [];
                    deletedIds.forEach(i => { 
                        delete state.planShiftMap[i];
                    });
                    resolve(state.planShiftMap);
                }).catch(function (error) {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.deleteInvalidError'));
                    resolve(state.planShiftMap);
                });
            } else {
                resolve(state.planShiftMap);
            }
        });
        
    },
    deleteInvalidShiftsProcess(input){
        let view = this;
        this.refreshState().then(res => {
            view.deleteInvalidTemplateShifts(input.keepAssigned)
        }).catch(function (error) {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.deleteShiftsError'));
            
        });
    },
    deleteInvalidTemplateShifts(keepAssigned){
        let state = this.state;
        let view = this;
        let checkMap = this.generateShiftTemplateCheckMap(state);
        let shiftsToDelete = [];
        let countMap = {};
        let shifts = [];
        if(keepAssigned){
            shifts = Object.values(state.planShiftMap).filter(s => !s.published && s.templateId != null && s.employeeId == null);
        } else {
            shifts = Object.values(state.planShiftMap).filter(s => !s.published && s.templateId != null);
        }
        let rosterFrom = this.$helpers.getMomentFromStringTZ(state.rosterFromTo.from);
        let rosterTo = this.$helpers.getMomentFromStringTZ(state.rosterFromTo.to);

        shifts.forEach(s => {
            if(s.historicFrom){
                let d = this.$helpers.getMomentFromStringTZ(s.historicFrom);
                if(d >= rosterFrom && d < rosterTo){
                    //only delete within roster from to
                    let checkKey = this.$helpers.getMomentFromStringTZ(s.historicFrom).format('YYYY-MM-DD')+"-"+s.templateId;
                    if(!countMap[checkKey]){
                        countMap[checkKey] = 0;
                    }
                    countMap[checkKey] += 1;
                    let currentCount = countMap[checkKey];
                    let supposedToCount = checkMap[checkKey];
                    if(supposedToCount == null || currentCount > supposedToCount){
                        shiftsToDelete.push(s.id);
                    }
                }
                
            }
            
        })
        if(shiftsToDelete.length > 0){
            let url = '/api/sec/planshift/any/delete';
    
            let payload = {
                ids: shiftsToDelete,
            }
            view.$helpers.RecursivePOSTAny(url, payload, [])
            .then(result => {
                let deletedIds = result;
                let payload = [];
                deletedIds.forEach(i => { let x = {mapName : 'planShiftMap', id: i }; payload.push(x) });
                view.$store.commit("deleteMultiple",payload);
                view.$store.commit("invalidateState", {states: ['planShiftMapState']});
                view.$emit("refreshShifts");        
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.shiftsDeleted'));
            }).catch(function (error) {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.deleteShiftsError'));
            });
        } else {
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.invalidShiftsFound'));
        }
    },
    createShiftImportResultsCSV(data){
        let csvPre = "data:text/csv;charset=utf-8,";
        // e.address, e.postalCode, e.city, e.iban, e.bic,
        let keys = [];
        if(data.validOriginalEntries.length > 0){
            keys = Object.keys(data.validOriginalEntries[0]);
        }else{
            keys = Object.keys(data.invalidEntries[0]);
        }
        let csv = keys.join(";");

        // rename headers to not expose our internal field names
        csv = csv.replace("fromTime", "Beginn-Zeit");
        csv = csv.replace("toTime", "End-Zeit");
        csv = csv.replace("date", "Datum");
        csv = csv.replace("workValue", "Arbeitszeit+Pauschale(Wert des Dienstes)");
        csv = csv.replace("businessunit", "Bereich");
        csv = csv.replace("spot", this.$tc('shift.main.position'));
        csv = csv.replace("position", this.$tc('shift.main.position'));

        csv += ";Import erfolgreich;Fehler\r\n";
        let fields = [];
        data.validOriginalEntries.forEach(element => {
            fields = [];
            keys.forEach((k) => {
                fields.push(element[k]);
            });
            fields.push(this.$t('global.ui.yes').toUpperCase());
            csv += fields.join(";");
            csv += ";\r\n";
        });

        data.invalidEntries.forEach(element => {
            fields = [];
            keys.forEach((k) => {
                fields.push(element[k]);
            });
            fields.push(this.$t('global.ui.no').toUpperCase());
            csv += fields.join(";");
            csv += ";" + element.cause;
            csv += "\r\n";
        });

        let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "import-results.csv");
        document.body.appendChild(link); // Required for FF

        link.click();
    },
    openCSVImportPopup() {
        let view = this;
            
        let dataEntries = [
            {label: this.$t('global.ui.csvFile'), accept: ".csv", key: 'file', hidden: false, type: 'file', value: null},
            {label: this.$t('shift.main.deleteUnfilledShifts'), key: 'deletePrevShifts', hidden: false, type: 'bool', value: false},
            {label: this.$t('shift.main.overwriteAutoBreaks'), key: 'overrideBreak', hidden: false, type: 'bool', value: false},
            {
                label: this.$t('store.settings.breakTime'), key: 'breakValue', hidden: this.$helpers.CheckDatafillKeysForHidden('overrideBreak'), value: 0,
                slider: {
                    hideMin: false,
                    hideMax: false,
                    min: 0,
                    max: 120,
                    value: 0,
                    step: 1,
                    inputControl: true,
                    sliderInput: (x) => { return x },
                },            
            },
        ];

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                selectCallback: function (importf) {
                    if(importf.file.length > 0){
                        view.$helpers.GetPlanShiftMap().then(map=> {
                            view.planShiftMap = map;
                            return view.$helpers.GetSpotMap()
                        })
                        .then(map => {
                            view.spotMap = map;
                            return view.parseCSVImport(importf.file[0], importf.overrideBreak, importf.breakValue);
                        })
                        .then(data => {
                            
                            
                            if(data.validEntries.length > 0){
                                if(importf.deletePrevShifts){
                                    let deleteIds = Object.values(view.planShiftMap).filter(shift => {
                                        let shiftFrom = view.$helpers.getMomentFromStringTZ(shift.from);
                                        return shift.employeeId == null && !shift.locked && shiftFrom.year() == view.rosterFromTo.year && shiftFrom.month() == view.rosterFromTo.month;
                                    }).map(shift => shift.id);
                                    return view.deleteShifts(deleteIds).then(res => {
                                        view.createShifts(data.validEntries).then((response) => {
                                            data.numImportedShifts = response.data.data.length;
                                            view.createShiftImportResultsCSV(data);
                                            return new Promise((resolve, reject) => resolve([]));
                                        });
                                    })
                                } else {
                                    view.createShifts(data.validEntries).then((response) => {
                                        data.numImportedShifts = response.data.data.length;
                                        view.createShiftImportResultsCSV(data);
                                        return new Promise((resolve, reject) => resolve([]));
                                    });
                                }
                            } else {
                                data.numImportedShifts = 0;
                                view.createShiftImportResultsCSV(data);
                                return new Promise((resolve, reject) => resolve([]));
                            }
                            
                        }).then(res => {
                            view.$emit("refreshShifts");
                            view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.shiftsImported'));
                        }).catch(error => {
                            console.log(error);
                            view.$emit("refreshShifts");
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.importDataError'));
                        })
                            
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.noImportFileSelected'));
                    }   
                },
            },
            header: this.$t('shift.main.importShifts'),
            width: '700px',
            remainAfterSelect: false,
            expanded: true,
            centered: true
        });
    },
    parseCSVImport(file, overrideBreak =  false, breakValue = 0){
        let view = this;
        return new Promise((resolve, reject) => {
            Papa.parse(file, 
            {
                header: true,
                skipEmptyLines: true,
                transformHeader: (header) => {
                    if(header){
                        header = header.trim(); //.toLowerCase();
                    }
                    if(header == "Arbeitszeit+Pauschale(Wert des Dienstes)"){
                        return "workValue";
                    }
                    if(header == "Datum"){
                        return "date";
                    }
                    if(header == "Beginn-Zeit"){
                        return "fromTime";
                    }
                    if(header == "End-Zeit"){
                        return "toTime"
                    }
                    if(header == this.$tc('shift.main.position')){
                        return "position"
                    }
                    if(header == "Bereich"){
                        return "businessunit"
                    } else {
                        return header;
                    }

                },
                complete: (result, file) => {
                    try {
                       let cleanResult = view.cleanupAndExtendImportData(result.data, overrideBreak, breakValue); 
                      
                       resolve(cleanResult);
                    } catch (error) {
                        console.log(error);
                        reject(error);
                    }
                    
                     
                        
                },
                error: (error, file) => {
                    reject(error);
                                   
                }
            })
        })
            
    },
    cleanupAndExtendImportData(data, overrideBreak = true, breakValue = 0){
        let view = this;
        let spotNameMap = {};
        Object.values(this.spotMap).forEach(spot => {
            spotNameMap[spot.name] = spot;
        })
        let validEntries = [];
        let invalidEntries = [];
        let validOriginalEntries = [];
        
        data.forEach(entry => {
            let cause = "";
            let shift = {storeId: this.storeId, from: null, to: null, spotId: null, workValue: -1, holidayWorkValue: -1, workValueMultiplier: 1.0, skillMultiplier: 1, breakValue: 0, historicBreakValue: 0, tasks: []};
            
            let valid = true;
            if(entry.date){
                let date = this.$helpers.getMomentFromStringTZ(entry.date, "DD.MM.YYYY");
                if(entry.fromTime){
                    let fromT = this.$helpers.getMomentFromStringTZ(entry.fromTime, "HH:mm:ss")
                    shift.from = this.$helpers.getMomentFromValuesTZ(date.year(), date.month(), date.date(), fromT.hours(), fromT.minutes());
                } else {
                    cause = "Beginn-Zeit fehlt";
                   valid = false; 
                }
                if(entry.toTime){
                    let toT = this.$helpers.getMomentFromStringTZ(entry.toTime, "HH:mm:ss")
                    shift.to = this.$helpers.getMomentFromValuesTZ(date.year(), date.month(), date.date(), toT.hours(), toT.minutes());
                    if(shift.to <= shift.from){
                        shift.to.add(1, 'days');
                    }
                } else {
                    cause = "End-Zeit fehlt";
                   valid = false; 
                }  
                if(shift.from){
                    if(shift.from.year() != this.rosterFromTo.year || shift.from.month() != this.rosterFromTo.month){
                        cause = "Schicht nicht im aktuell ausgewählten Monat";
                        valid = false;
                    }
                    shift.from = shift.from.format();
                }    
                if(shift.to){
                    shift.to = shift.to.format();
                }
                if(shift.from == "Invalid date"){
                    shift.from = null;
                    cause = "Ungültiges Datumsformat";
                    valid = false; 
                }
                if(shift.to == "Invalid date"){
                    shift.to = null;
                    cause = "Ungültiges Datumsformat";
                    valid = false; 
                }
                
            } else {
                cause = "Datum fehlt";
                valid = false;
            }
            
            if(entry.position){
                let spotId = spotNameMap[entry.position] ? spotNameMap[entry.position].id : null;
                if(spotId){
                    shift.spotId = spotId;
                } else {
                    cause = "Position nicht gefunden";
                    valid = false;
                }
            } else {
                cause = "Position fehlt";
                valid = false;
            }
            if(entry.workValue){
                let split = entry.workValue.split(":");
                if(split.length >= 2){
                    let hours = parseInt(split[0])
                    let minutes = parseInt(split[1]);
                    if(!isNaN(hours) && !isNaN(minutes) ){
                        shift.workValue = hours*60+minutes;
                    } else {
                        cause = "Wert des Dienstes ungültig";
                        valid = false;
                    }
                } else {
                    cause = "Wert des Dienstes ungültig";
                    valid = false;
                }
            } else {
                shift.workValue = -1;
            }
            if(valid){
                validOriginalEntries.push(Object.assign({}, entry));
                delete entry.workValue;
                delete entry.position;
                delete entry.date;
                delete entry.businessunit;
                delete entry.fromTime;
                delete entry.toTime;
                delete entry.position;
                if(overrideBreak){
                    shift.breakValue = breakValue;
                    let sFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                    let sTo = this.$helpers.getMomentFromStringTZ(shift.to);
                    let diff = sTo.diff(sFrom, 'minutes');
                    
                    shift.breakFrom = sFrom.clone().add(diff/2.0, 'minutes').format();
                }
                Object.keys(entry).forEach(key => {
                    shift.tasks.push({label: key, value: entry[key]});
                    
                });
                validEntries.push(shift)
            } else {
                entry.cause = cause;
                invalidEntries.push(entry);
            } 
            
        })
        return {validEntries: validEntries, invalidEntries: invalidEntries, validOriginalEntries: validOriginalEntries};
    },

    checkValidOverlap(weekStart, weekEnd, validFrom, validTo){
        let result = false;
        if(validFrom == null && validTo == null){
            result = true;
        } else if(validFrom == null){
            result = weekEnd <= validTo;
        } else if(validTo == null){
            result = weekStart >= validFrom;
        } else {
            result =  validTo > weekStart && validFrom < weekEnd
        }
        return result;
    },
    createShiftSkillsWithTemplate: function(requests){
        
        let url = '/api/sec/shiftskillrequirement/multi';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement/multi');

        let payload = {
                requests: requests
        }
                
        return  this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
        })
    },
    loadShiftTemplateGroups : function(storeId) {
     
        let url = '/api/sec/shifttemplategroup';

        url = this.$helpers.appendParam("storeId", storeId, url, '/api/sec/shifttemplategroup');
 
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
			
    },
    updateShiftTemplateGroups : function(data){
        let tshiftTemplateGroupMap = {};

        for (let i = 0; i < data.length; i++) {
            tshiftTemplateGroupMap[data[i].id] = data[i];     
        }
        this.shiftTemplateGroupMap = tshiftTemplateGroupMap;
    },
    loadShiftTemplatesPagedCompletely : function(payload, storeId, rosterFromTo, page = 1, data = []) {

        let url = '/api/sec/shifttemplate/any/event';
        let from = this.$helpers.getMomentFromStringTZ(rosterFromTo.from).add(-1, 'days').format();
        let to =this.$helpers.getMomentFromStringTZ(rosterFromTo.to).add(1, 'days').format();
        let params = {
            storeId: storeId,
            validFrom: from,
            validTo: to,
            page: page,
            validGroup: true
        }

        return this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            if (response.data.length < 1 ) {
                return data;
            } else {
                data.push(...response.data);
                 return this.loadShiftTemplatesPagedCompletely (payload, storeId, rosterFromTo, page+1, data);
            }


        })


    },
    
    loadShiftTemplateSkills : function(payload, storeId) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shifttemplateskillrequirement/any/template';

            let params = {
                storeId: storeId,
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }
    },
    
    updateShiftTemplateSkills: function(data){
        
        let map = {};
        for (let i = 0; i < data.length; i++) {
            map[data[i].id] =data[i];
            if(this.shiftTemplateMap[data[i].templateId] != undefined){
                if(this.shiftTemplateMap[data[i].templateId].requiredSkills == undefined){
                    this.shiftTemplateMap[data[i].templateId].requiredSkills = []
                }
                this.shiftTemplateMap[data[i].templateId].requiredSkills.push(data[i].id);
            }
        }
        this.shiftTemplateSkillMap = map;
    },
    updateShiftTemplates : function(data, spotMap, storeEventMap){
        let overviewA = [];
        let map = {};
        var i;
        for (i = 0; i < data.length; i++) {
            
            map[data[i].id] = data[i]; 
            let shiftTemplateItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                weekDays: data[i].weekDays,
                count: data[i].count
            }
            
            if(!this.$helpers.isBlank(data[i].spotId)){
                shiftTemplateItem.spot = spotMap[data[i].spotId].name;
            } else {
                shiftTemplateItem.spot = "";
            }
            if(!this.$helpers.isBlank(data[i].eventId)){
                shiftTemplateItem.event = storeEventMap[data[i].eventId].name;
            } else {
                shiftTemplateItem.event = "";
            }
            overviewA.push(shiftTemplateItem);
        }
        this.shiftTemplateMap = map;
        this.shiftTemplates = overviewA;
    },
    loadShiftTemplateGroupFrames: function(storeId, rosterFromTo) {
        let url = '/api/sec/shifttemplategroupframe';
        let year = rosterFromTo.year; 
        let startOfYear = this.$helpers.getMomentFromValuesTZ(year, 0, 1);
        let params = {
            storeId: storeId,
            from: startOfYear.clone().date(15).month(11).subtract(1, 'year').format(),
            to: startOfYear.clone().date(15).month(0).add(1, 'year').format(),     
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        });
    },
    updateShiftTemplateGroupFrames: function(data){
        let i;
        let tgroupframes = {}
        for (i = 0; i < data.length; i++) {
            let item = data[i];
            item.fromMoment = item.from ? this.$helpers.getMomentFromStringTZ(item.from) : null;
            item.toMoment = item.to ? this.$helpers.getMomentFromStringTZ(item.to) : null;
            tgroupframes[data[i].id] = item;
            
        }
        this.shiftTemplateGroupFrameMap = tgroupframes;
    },
    
    loadStoreEvents: function(storeId, rosterFromTo) {
        let url = '/api/sec/storeevent';
                
        let params = {
            storeId: storeId,
            active: true,
            from: rosterFromTo.from,
            to: rosterFromTo.to
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        });
    },
    updateStoreEvents: function(data){
        let i;
        let tstoreevents = {}
        for (i = 0; i < data.length; i++) {
            let item = data[i];
            item.fromMoment = this.$helpers.getMomentFromStringTZ(item.from);
            item.toMoment = this.$helpers.getMomentFromStringTZ(item.to);
            tstoreevents[data[i].id] = item;
            
        }
        this.storeEventMap = tstoreevents;
    },
    
    updateEmployees: function(data){
        var i;
        let temployees = {}
        for (i = 0; i < data.length; i++) {
            temployees[data[i].id] =data[i];
        }
        this.employeeMap = temployees;
    },
    
  },
 

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>
.md-card {
    position: fixed;
    z-index: 1000000;
    padding-bottom: 10px;
    top: 143px;
    left: 20%;
    right: auto;
    overflow: hidden;
}

.pad010 {
    padding: 0 10px;
}

.pad100 {
    padding: 10px 0;
}
</style>
